import React, { useEffect, useState } from "react";
import imgGizi1 from "../../../assets/img_major01_1.jpg";
import imgGizi2 from "../../../assets/img_major01_2.jpg";
import imgGizi3 from "../../../assets/img_major01_3.jpg";

const MajorTab1 = props => {
    return (
        <>
            {/* 기지국/중계기 운용관리 */}
            <div className="tab-cont">
                <h2 className="major-in-h2">
                    BUSINESS <em>사업소개</em>
                </h2>
                <p className="major-sbj">{props.title ? props.title : "네트워크 유지보수"}</p>
                <div className="person-gray-wrap gray-back-bg">
                    <div className="major-img-wrap">
                        <ul>
                            <li>
                                <img src={imgGizi1} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi2} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi3} alt="이미지" />
                            </li>
                        </ul>
                    </div>
                    <div className="mojor-business-wrap">
                        {/* <p className="cate">주요사업 업무</p> */}
                        <ul className="list">
                            <li className="hoverWraps">
                                <p className="hoverText">5G 네트워크 구축 및 운용</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- 5G 기지국/중계기 장비 셋업 및 개통</p>
                                        <p>- 전국 85개 도시 실내/외 24시간 5G 서비스 제공</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">네트워크 망 관리 및 점검</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- LTE, 3G, 인터넷 등 통신망 안전운용 및 현장 점검</p>
                                        <p>- 지상/지하, 지하철, 터널구간 고품질 제공 및 상시 장비점검</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">재난안전통신망 구축, 관제, 점검, 유지보수</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- PS-LTE 기반 전국 규모 공공안전통신망 구축, 유지보수</p>
                                        <p>- 차량형 이동기지국 개통 재난/재해지역 무선 통신서비스 제공</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">네트워크 시스템, 실시간 네트워크 망 장애 및 성능감시</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- 기지국, 중계기, 인터넷 등통신망 인프라 24시간 운영관리</p>
                                        <p>- 전체 장비 원격 관제 시스템 구성 및 실시간 알람 감시</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    {/* <p className="mojor-text">이동국(가입자단말기)과 이동전화 교환국 사이에 위치하여 이동국과의 무선전송과 교환국의 요청 있을 경우 통화중인 이동국의 신호강도를 측정하여 제공함으로써 이동전화 교환국이 이동국의 이동상황을 파악하는데 필요한 정보를 제공합니다.</p>

                    <p className="major-sbj">기지국</p>
                    <p className="mojor-text">기지국은 기저대역 신호처리, 유무선 변환 및 무선신호의 송수신 등을 수행하여 가입자 단말기와 CAI(COMMON AIR INTERFACE)로 직접 연결되는 망 종단장치입니다.</p> */}
                </div>
            </div>
        </>
    );
};

export default MajorTab1;
